import { render, staticRenderFns } from "./Arquivo.vue?vue&type=template&id=7edac2ca&"
import script from "./Arquivo.vue?vue&type=script&lang=js&"
export * from "./Arquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports